import * as React from "react";

import { Table } from "../Table";
import { Pie } from "../Pie";
import { Series } from "../Series";
import { FilterList } from "../FilterList";
import { DayFilter, UserFilter, getStore } from "../../store";
import { observer } from "mobx-react-lite";

export const App = observer(() => {
  const store = getStore();

  const daySelected = (day: number) => {
    store.addFilter(new DayFilter(day));
  };

  const userSelected = (userId: string, userName: string) => {
    store.addFilter(new UserFilter(userId, userName));
  };

  const onRemoveFilter = (index: number) => {
    store.removeFilter(index);
  };

  return (
    <div>
      <FilterList filters={store.filters} onRemoveFilter={onRemoveFilter} />
      <div className="row">
        <div className="col-md-7">
          <Series logs={store.currentLogs} daySelected={daySelected} />
        </div>
        <div className="col-md-5">
          <Pie logs={store.currentLogs} userSelected={userSelected} />
        </div>
      </div>
      <Table logs={store.currentLogs} />
    </div>
  );
});
